/* Matmuis: productpagina bureau-setup (Baymard, 24 okt 2026). Hoort bij sections/mm-bs-pdp.liquid */
(function () {
  var root = document.querySelector('[data-bp]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var $ = function (q, el) { return (el || root).querySelector(q); };
  var $$ = function (q, el) { return [].slice.call((el || root).querySelectorAll(q)); };
  var mqMob = window.matchMedia('(max-width: 989px)');
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* Hoogte van een vaste header, zodat de inhoudsbalk eronder past */
  function topOffset() {
    var h = 0;
    $$('.shopify-section-group-header-group, header', document).forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position === 'sticky' || cs.position === 'fixed') { var r = el.getBoundingClientRect(); if (r.top <= 0 && r.bottom > h) h = r.bottom; }
    });
    root.style.setProperty('--bp-top', Math.max(0, Math.round(h)) + 'px');
  }
  topOffset();
  window.addEventListener('resize', topOffset);

  /* Terug naar resultaten: alleen als je via een categorie of zoekopdracht hier kwam */
  var back = $('[data-bp-back]');
  try {
    var ref = document.referrer ? new URL(document.referrer) : null;
    if (back && ref && ref.host === location.host && /^\/(collections|search|pages)/.test(ref.pathname)) {
      back.href = ref.href;
      back.hidden = false;
      back.addEventListener('click', function (e) { if (history.length > 1) { e.preventDefault(); history.back(); } });
    }
  } catch (e) {}

  /* ===== Galerij ===== */
  var track = $('[data-bp-track]');
  var slides = $$('[data-bp-slide]');
  var thumbs = $$('[data-bp-thumb]');
  var countEl = $('[data-bp-count]');
  var cur = 0;
  function setActive(i) {
    cur = i;
    thumbs.forEach(function (b) { b.classList.toggle('is-on', +b.getAttribute('data-bp-thumb') === i); });
    if (countEl) countEl.textContent = (i + 1) + ' / ' + slides.length;
    var mt = $('.bp-mthumbs [data-bp-thumb="' + i + '"]');
    if (mt && mqMob.matches) { var p = mt.parentNode.parentNode; p.scrollTo({ left: mt.parentNode.offsetLeft - 20, behavior: 'smooth' }); }
    $$('video', track).forEach(function (vd, k) { if (!vd.paused) vd.pause(); });
  }
  function go(i, smooth) {
    if (!track) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    setActive(i);
  }
  var st = null;
  if (track) track.addEventListener('scroll', function () {
    clearTimeout(st);
    st = setTimeout(function () { var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); if (i !== cur) setActive(i); }, 60);
  }, { passive: true });
  thumbs.forEach(function (b) {
    var i = +b.getAttribute('data-bp-thumb');
    b.addEventListener('click', function () {
      if (b.querySelector('[data-bp-more]')) { openLb(i); return; }
      go(i, mqMob.matches);
    });
    b.addEventListener('mouseenter', function () { if (canHover.matches && !mqMob.matches && !b.querySelector('[data-bp-more]')) go(i, false); });
  });

  /* Zoom bij hover: los zoomvenster naast de foto, met een kader op het vergrote stuk */
  var stage = $('[data-bp-stage]'), lens = $('[data-bp-lens]'), zw = $('[data-bp-zoomwin]'), hero = $('[data-bp-hero]'), info = $('[data-bp-info]');
  var zTimer = null, zOn = false, zData = null;
  function drawnRect(img) {
    var bw = img.clientWidth, bh = img.clientHeight, cs = getComputedStyle(img);
    var pl = parseFloat(cs.paddingLeft) || 0, pt = parseFloat(cs.paddingTop) || 0;
    var iw = bw - pl * 2, ih = bh - pt * 2;
    var nw = img.naturalWidth || iw, nh = img.naturalHeight || ih;
    var sc = Math.min(iw / nw, ih / nh);
    var dw = nw * sc, dh = nh * sc;
    return { x: pl + (iw - dw) / 2, y: pt + (ih - dh) / 2, w: dw, h: dh, nw: nw, nh: nh };
  }
  function zoomStart(sl) {
    var img = sl.querySelector('img');
    if (!img || !img.complete) return;
    var full = new Image();
    full.src = sl.getAttribute('data-full');
    var r = drawnRect(img);
    var natW = +sl.getAttribute('data-w') || r.nw;
    var zwW = info.offsetWidth, zwH = stage.offsetHeight;
    var bgW = Math.min(Math.max(r.w * 2, natW), r.w * 4);
    var f = bgW / r.w;
    zData = { img: img, r: r, f: f, bgW: bgW, bgH: bgW * r.h / r.w, zwW: zwW, zwH: zwH, lw: Math.min(r.w, zwW / f), lh: Math.min(r.h, zwH / f), sl: sl };
    var hr = hero.getBoundingClientRect(), sr = stage.getBoundingClientRect(), ir = info.getBoundingClientRect();
    zw.style.left = (ir.left - hr.left) + 'px';
    zw.style.top = (sr.top - hr.top) + 'px';
    zw.style.width = zwW + 'px';
    zw.style.height = zwH + 'px';
    zw.style.backgroundImage = 'url("' + full.src + '")';
    zw.style.backgroundSize = zData.bgW + 'px ' + zData.bgH + 'px';
    lens.style.width = zData.lw + 'px';
    lens.style.height = zData.lh + 'px';
    zOn = true;
    stage.classList.add('is-zoom');
    root.classList.add('is-zoom');
  }
  function zoomStop() { clearTimeout(zTimer); zOn = false; zData = null; stage && stage.classList.remove('is-zoom'); root.classList.remove('is-zoom'); }
  function zoomMove(e) {
    if (!zOn || !zData) return;
    var ir = zData.img.getBoundingClientRect(), r = zData.r;
    var mx = e.clientX - ir.left, my = e.clientY - ir.top;
    if (mx < r.x || mx > r.x + r.w || my < r.y || my > r.y + r.h) { zoomStop(); return; }
    var lx = Math.max(r.x, Math.min(r.x + r.w - zData.lw, mx - zData.lw / 2));
    var ly = Math.max(r.y, Math.min(r.y + r.h - zData.lh, my - zData.lh / 2));
    var sr = stage.getBoundingClientRect();
    lens.style.left = (ir.left - sr.left + lx) + 'px';
    lens.style.top = (ir.top - sr.top + ly) + 'px';
    zw.style.backgroundPosition = (-(lx - r.x) * zData.f) + 'px ' + (-(ly - r.y) * zData.f) + 'px';
  }
  if (stage && zw && info) {
    slides.forEach(function (sl) {
      if (!sl.hasAttribute('data-full')) return;
      sl.addEventListener('mousemove', function (e) {
        if (!canHover.matches || mqMob.matches) return;
        if (zOn) { zoomMove(e); return; }
        var img = sl.querySelector('img'); if (!img) return;
        var ir = img.getBoundingClientRect(), r = drawnRect(img), mx = e.clientX - ir.left, my = e.clientY - ir.top;
        var inside = mx >= r.x && mx <= r.x + r.w && my >= r.y && my <= r.y + r.h;
        if (!inside) { clearTimeout(zTimer); zTimer = null; return; }
        if (!zTimer) { var ev = e; zTimer = setTimeout(function () { zTimer = null; zoomStart(sl); zoomMove(lastMove || ev); }, 300); }
        lastMove = e;
      });
      sl.addEventListener('mouseleave', zoomStop);
    });
  }
  var lastMove = null;
  window.addEventListener('scroll', function () { if (zOn) zoomStop(); }, { passive: true });

  /* ===== Grote weergave (overlay) ===== */
  var lb = $('[data-bp-lb]'), lbImg = $('[data-bp-lb-img]'), lbStage = $('[data-bp-lb-stage]'), lbInfo = $('[data-bp-lb-info]'), lbThumbs = $('[data-bp-lb-thumbs]');
  var imgSlides = slides.filter(function (sl) { return sl.hasAttribute('data-full'); });
  var lbI = 0;
  if (lb && lbThumbs) {
    lbThumbs.innerHTML = imgSlides.map(function (sl, k) {
      var im = sl.querySelector('img');
      return '<button type="button" class="bp-thumb" data-k="' + k + '" aria-label="Foto ' + (k + 1) + '"><img src="' + (im ? (im.currentSrc || im.src) : '') + '" alt=""></button>';
    }).join('');
    $$('button', lbThumbs).forEach(function (b) { b.addEventListener('click', function () { showLb(+b.getAttribute('data-k')); }); });
  }
  function unzoom() { lbStage.classList.remove('is-zoom'); lbStage.scrollLeft = 0; lbStage.scrollTop = 0; lbInfo.textContent = (lbI + 1) + ' van ' + imgSlides.length + (mqMob.matches ? ' · tik om in te zoomen' : ' · klik op de foto om in te zoomen'); }
  function showLb(k) {
    lbI = (k + imgSlides.length) % imgSlides.length;
    var sl = imgSlides[lbI];
    lbImg.src = sl.getAttribute('data-full');
    var im = sl.querySelector('img');
    lbImg.alt = im ? im.alt : '';
    $$('button', lbThumbs).forEach(function (b, j) { b.classList.toggle('is-on', j === lbI); });
    unzoom();
  }
  function openLb(k) {
    if (!lb || !imgSlides.length) return;
    var sl = slides[k];
    var idx = imgSlides.indexOf(sl);
    zoomStop();
    showLb(idx < 0 ? 0 : idx);
    if (typeof lb.showModal === 'function') {
      lb.showModal();
      try { history.pushState({ bpLb: 1 }, ''); } catch (e) {}
    } else { window.open(lbImg.src, '_blank'); }
  }
  slides.forEach(function (sl, k) {
    if (!sl.hasAttribute('data-full')) return;
    sl.addEventListener('click', function () { openLb(k); });
    sl.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLb(k); } });
  });
  if (lb) {
    $('[data-bp-lb-close]').addEventListener('click', function () { lb.close(); });
    lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
    lb.addEventListener('close', function () { unzoom(); if (history.state && history.state.bpLb) { try { history.back(); } catch (e) {} } });
    window.addEventListener('popstate', function () { if (lb.open) lb.close(); });
    $$('[data-bp-lb-nav]').forEach(function (b) { b.addEventListener('click', function () { showLb(lbI + (+b.getAttribute('data-bp-lb-nav'))); }); });
    lb.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') showLb(lbI + 1); if (e.key === 'ArrowLeft') showLb(lbI - 1); });
    lbStage.addEventListener('click', function (e) {
      if (lbStage.classList.contains('is-zoom')) { unzoom(); return; }
      var r = lbImg.getBoundingClientRect(), dr = drawnRect(lbImg);
      var px = (e.clientX - r.left - dr.x) / dr.w, py = (e.clientY - r.top - dr.y) / dr.h;
      if (px < 0 || px > 1 || py < 0 || py > 1) return;
      var zwidth = Math.max(lbImg.naturalWidth || 0, lbStage.clientWidth * 2.2);
      lbStage.style.setProperty('--zw', zwidth + 'px');
      lbStage.classList.add('is-zoom');
      lbInfo.textContent = mqMob.matches ? 'Sleep om te bewegen · tik om uit te zoomen' : 'Beweeg om rond te kijken · klik om uit te zoomen';
      requestAnimationFrame(function () {
        lbStage.scrollLeft = px * lbImg.offsetWidth - lbStage.clientWidth / 2;
        lbStage.scrollTop = py * lbImg.offsetHeight - lbStage.clientHeight / 2;
      });
    });
    lbStage.addEventListener('mousemove', function (e) {
      if (!lbStage.classList.contains('is-zoom') || !canHover.matches) return;
      var r = lbStage.getBoundingClientRect();
      lbStage.scrollLeft = ((e.clientX - r.left) / r.width) * (lbImg.offsetWidth - lbStage.clientWidth);
      lbStage.scrollTop = ((e.clientY - r.top) / r.height) * (lbImg.offsetHeight - lbStage.clientHeight);
    });
  }

  /* ===== Koopblok ===== */
  var form = $('[data-bp-form]'), atc = $('[data-bp-atc]'), err = $('[data-bp-err]');
  var qty = $('.bp-qty input');
  $$('[data-bp-qty]').forEach(function (b) {
    b.addEventListener('click', function () { qty.value = Math.min(99, Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-bp-qty'), 10))); });
  });
  if (form && atc) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc.disabled || atc.classList.contains('is-loading')) return;
      atc.classList.add('is-loading');
      if (err) err.hidden = true;
      var drawer = document.querySelector('cart-drawer');
      var fd = new FormData(form);
      try {
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          fd.append('sections', drawer.getSectionsToRender().map(function (x) { return x.id; }).join(','));
          fd.append('sections_url', window.location.pathname);
        }
      } catch (x) {}
      var base = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
      fetch(base + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          atc.classList.remove('is-loading');
          if (j && j.status) { if (err) { err.textContent = j.description || j.message || 'Toevoegen lukte niet.'; err.hidden = false; } return; }
          document.dispatchEvent(new CustomEvent('cart:updated'));
          if (drawer && typeof drawer.renderContents === 'function' && j.sections) {
            try { drawer.classList.remove('is-empty'); drawer.renderContents(j); return; } catch (x) {}
          }
          window.location.href = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
        })
        .catch(function () { atc.classList.remove('is-loading'); form.submit(); });
    });
    $$('[data-bp-buy]').forEach(function (b) { b.addEventListener('click', function () { if (typeof form.requestSubmit === 'function') form.requestSubmit(); else atc.click(); }); });
  }

  /* Leverdatum: 'Voor 18:00 besteld, morgen in huis' wordt een concrete datum met aftelling; 'x-y werkdagen' wordt een datumbereik */
  var dv = $('[data-bp-deliv]');
  if (dv) {
    var txt = dv.getAttribute('data-text') || '', low = txt.toLowerCase();
    var mainEl = $('[data-bp-deliv-main]', dv), noteEl = $('[data-bp-deliv-note]', dv);
    var nlNow = function () { try { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' })); } catch (x) { return new Date(); } };
    var fmt = function (d) { try { return d.toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short' }); } catch (x) { return d.getDate() + '-' + (d.getMonth() + 1); } };
    var addWorkdays = function (d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) n--; } return x; };
    var mh = txt.match(/(\d{1,2})[:.]00/), mr = low.match(/(\d+)\s*(?:-|tot|–)\s*(\d+)\s*werkdag/), m1 = low.match(/(\d+)\s*werkdag/);
    if (low.indexOf('morgen') > -1 && mh) {
      var hour = parseInt(mh[1], 10);
      var upd = function () {
        var n = nlNow(), d = n.getDay(), cut = new Date(n); cut.setHours(hour, 0, 0, 0);
        var before = d >= 1 && d <= 5 && n < cut;
        var ship = before ? n : addWorkdays(n, 1);
        var del = addWorkdays(ship, 1);
        var tomorrow = new Date(n); tomorrow.setDate(n.getDate() + 1);
        var isTomorrow = del.toDateString() === tomorrow.toDateString();
        var html = 'Verwacht in huis: <strong>' + (isTomorrow ? 'morgen, ' : '') + fmt(del) + '</strong>';
        if (before) { var mins = Math.floor((cut - n) / 60000); html += '<br>Bestel binnen <b>' + Math.floor(mins / 60) + 'u ' + (mins % 60 < 10 ? '0' : '') + (mins % 60) + 'm</b>, dan gaat het vandaag nog mee'; }
        mainEl.innerHTML = html;
        noteEl.hidden = false;
        setTimeout(upd, 30000);
      };
      upd();
    } else if (mr || m1) {
      var a = mr ? +mr[1] : +m1[1], b2 = mr ? +mr[2] : a, n0 = nlNow();
      mainEl.innerHTML = 'Verwacht in huis: <strong>' + (a === b2 ? fmt(addWorkdays(n0, a)) : 'tussen ' + fmt(addWorkdays(n0, a)) + ' en ' + fmt(addWorkdays(n0, b2))) + '</strong>';
      noteEl.hidden = false;
    }
  }

  /* ===== Secties: desktop open, mobiel inklapbaar ===== */
  var secs = $$('[data-bp-sec]');
  function setOpen(sec, open) {
    var h = $('.bp-sec__h', sec), b = $('.bp-sec__b', sec);
    h.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) b.removeAttribute('hidden'); else b.setAttribute('hidden', 'until-found');
    if (open) checkDesc();
  }
  function layout() {
    secs.forEach(function (sec) { setOpen(sec, !mqMob.matches || sec.hasAttribute('data-open')); });
  }
  secs.forEach(function (sec) {
    var h = $('.bp-sec__h', sec), b = $('.bp-sec__b', sec);
    h.addEventListener('click', function () {
      if (!mqMob.matches) return;
      var open = h.getAttribute('aria-expanded') !== 'true';
      if (open) sec.setAttribute('data-open', ''); else sec.removeAttribute('data-open');
      setOpen(sec, open);
    });
    b.addEventListener('beforematch', function () { sec.setAttribute('data-open', ''); setOpen(sec, true); });
  });
  layout();
  if (mqMob.addEventListener) mqMob.addEventListener('change', function () { layout(); zoomStop(); });

  /* Naar een sectie springen: open hem eerst op mobiel */
  function jump(id) {
    var t = document.getElementById(id);
    if (!t) return;
    if (t.hasAttribute('data-bp-sec') && mqMob.matches) { t.setAttribute('data-open', ''); setOpen(t, true); }
    t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    try { history.replaceState(history.state, '', '#' + id); } catch (e) {}
  }
  $$('[data-bp-jump], .bp-toc a').forEach(function (a) {
    a.addEventListener('click', function (e) { var id = (a.getAttribute('href') || '').replace('#', ''); if (id) { e.preventDefault(); jump(id); } });
  });
  if (location.hash && document.getElementById(location.hash.slice(1))) setTimeout(function () { jump(location.hash.slice(1)); }, 300);

  /* Omschrijving inkorten met een duidelijke knop */
  var desc = $('[data-bp-desc]');
  function checkDesc() {
    if (!desc || desc.classList.contains('is-open')) return;
    var body = $('.bp-desc__body', desc);
    desc.classList.toggle('is-long', body.scrollHeight > body.clientHeight + 30);
  }
  if (desc) {
    var ex = $('[data-bp-expand]', desc);
    ex.addEventListener('click', function () {
      var open = desc.classList.toggle('is-open');
      ex.setAttribute('aria-expanded', open ? 'true' : 'false');
      $('span', ex).textContent = open ? 'Minder tonen' : 'Lees de hele omschrijving';
      $('svg', ex).style.transform = open ? 'rotate(180deg)' : '';
      if (!open) desc.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
    checkDesc();
    window.addEventListener('load', checkDesc);
  }

  /* Specificaties: zoeken en alles open- of dichtklappen */
  var sInput = $('[data-bp-ssearch]'), sGroups = $$('[data-bp-sg]'), sNone = $('[data-bp-snone]'), sToggle = $('[data-bp-stoggle]');
  var sOpen0 = sGroups.map(function (g) { return g.open; });
  function unmark(el) { $$('mark', el).forEach(function (m) { m.replaceWith(document.createTextNode(m.textContent)); }); el.normalize(); }
  function markIn(el, q) {
    var walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), nodes = [], n;
    while ((n = walk.nextNode())) { if (!n.parentNode.closest('.bp-tipw')) nodes.push(n); }
    nodes.forEach(function (node) {
      var i = node.nodeValue.toLowerCase().indexOf(q);
      if (i < 0) return;
      var r = document.createRange(); r.setStart(node, i); r.setEnd(node, i + q.length);
      var m = document.createElement('mark'); r.surroundContents(m);
    });
  }
  function specSearch() {
    var q = (sInput.value || '').trim().toLowerCase(), hits = 0;
    sGroups.forEach(function (g, gi) {
      var gh = 0;
      $$('[data-bp-sr]', g).forEach(function (r) {
        unmark(r);
        var ok = !q || r.textContent.toLowerCase().indexOf(q) > -1;
        r.hidden = !ok;
        if (ok) { gh++; if (q) markIn(r, q); }
      });
      g.hidden = q && !gh;
      if (q) g.open = gh > 0; else g.open = sOpen0[gi];
      hits += gh;
    });
    if (sNone) sNone.hidden = !q || hits > 0;
  }
  if (sInput) {
    var sT = null;
    sInput.addEventListener('input', function () { clearTimeout(sT); sT = setTimeout(specSearch, 120); });
    sInput.addEventListener('keydown', function (e) { if (e.key === 'Escape') { sInput.value = ''; specSearch(); } });
  }
  if (sToggle) sToggle.addEventListener('click', function () {
    var openAll = sGroups.some(function (g) { return !g.open; });
    sGroups.forEach(function (g) { g.open = openAll; });
    sToggle.textContent = openAll ? 'Alles inklappen' : 'Alles openklappen';
  });

  /* Uitleg bij vaktermen in de specificaties */
  var TIPS = {
    'bewegingsresolutie': 'Hoe gevoelig de muis is, in DPI. Hoe hoger, hoe verder de cursor beweegt bij dezelfde handbeweging. 1000 tot 1600 DPI is prima voor kantoorwerk.',
    'vormfactor': 'Voor welke hand de vorm is gemaakt. Ambidextrous betekent geschikt voor links- en rechtshandigen.',
    'wireless ontvanger interface': 'In welke poort van je computer de draadloze ontvanger (dongle) gaat.',
    'ontvanger type': 'Het soort draadloze ontvanger. Met een Unifying- of Bolt-ontvanger verbind je meerdere Logitech-apparaten via één dongle.',
    'unifying receiver': 'Eén Logitech-ontvanger waarmee je tot zes Logitech-apparaten tegelijk verbindt.',
    'frequentieband': 'De radiofrequentie van de draadloze verbinding. 2,4 GHz is de standaard voor muizen en toetsenborden.',
    'aansluitbereik': 'Tot welke afstand de draadloze verbinding werkt.',
    'plug and play': 'Werkt direct na het aansluiten, zonder software te installeren.',
    'soort paneel': 'Het type scherm. IPS: mooie kleuren en kijkhoeken. VA: diep zwart en veel contrast. TN: snel, maar minder mooie kleuren.',
    'maximale refresh snelheid': 'Hoe vaak per seconde het beeld ververst, in Hz. 60 Hz is genoeg voor kantoorwerk; vanaf 120 Hz voelt alles vloeiender, vooral bij gamen.',
    'responstijd': 'Hoe snel een beeldpunt van kleur wisselt. Lager is beter tegen vegen bij snel bewegend beeld.',
    'beeldschermdiagonaal': 'De schermgrootte van hoek tot hoek, in inch. 1 inch is 2,54 cm.',
    'resolutie': 'Het aantal beeldpunten. Meer pixels geeft een scherper beeld en meer werkruimte.',
    'contrastverhouding': 'Het verschil tussen het lichtste wit en het donkerste zwart. Hoger betekent dieper zwart.',
    'helderheid': 'Hoe fel het scherm kan worden, in cd/m². 250 tot 300 is genoeg voor een kantoor.',
    'paneel montage-interface': 'Het schroefpatroon (VESA) achterop het scherm voor een monitorarm of muurbeugel, bijvoorbeeld 100 x 100 mm.',
    'vesa': 'Het standaard schroefpatroon achterop schermen voor een monitorarm of muurbeugel.',
    'hdcp': 'Kopieerbeveiliging die nodig is om bijvoorbeeld streamingdiensten in HD te bekijken.',
    'hostinterface': 'De aansluiting waarmee het product op je laptop of computer gaat.',
    'usb power delivery': 'Laadt je laptop op via dezelfde USB-C-kabel.',
    'thunderbolt': 'Een zeer snelle USB-C-aansluiting (tot 40 Gbit/s) voor docks en meerdere schermen.',
    'overdrachtssnelheid': 'Hoe snel gegevens worden verplaatst. 5 Gbit/s is USB 3.0, 10 Gbit/s is USB 3.2 Gen 2.',
    'usb-versie': 'Nieuwere USB-versies zijn sneller. USB 2.0 haalt 480 Mbit/s, USB 3.2 Gen 1 5 Gbit/s.',
    'capaciteit van de accu/batterij': 'Hoeveel energie de accu opslaat, in mAh. 10.000 mAh laadt een gemiddelde smartphone 2 tot 3 keer op.',
    'microfoontype': 'Boom: de microfoon zit aan een armpje voor je mond. Dat geeft de beste spraakkwaliteit bij bellen.',
    'headset type': 'Stereo: geluid in beide oren. Mono: één oorschelp, handig als je je omgeving wilt blijven horen.',
    'face tracking': 'De camera houdt je gezicht automatisch in beeld als je beweegt.',
    'kijkhoek': 'Vanaf welke hoek je het beeld nog goed ziet.',
    'printtechnologie': 'Inkjet: goedkoper in aanschaf en goed voor foto\'s. Laser: lagere kosten per pagina en snel bij veel tekst.',
    'duplex printen': 'Automatisch dubbelzijdig printen.',
    'beeldverhouding': 'De verhouding tussen breedte en hoogte. 16:9 is standaard, 21:9 is ultrawide.',
    'bluetooth-versie': 'Nieuwere versies verbruiken minder stroom en verbinden stabieler.',
    'ruisonderdrukking': 'Filtert omgevingsgeluid weg, zodat jij of je gesprekspartner minder achtergrondlawaai hoort.',
    'daisy chain': 'Meerdere schermen achter elkaar doorlussen met één kabel vanaf je computer.',
    'hdr': 'High Dynamic Range: meer detail in heel lichte en heel donkere delen van het beeld.',
    'flicker free': 'Het scherm knippert niet, wat vermoeiende ogen helpt voorkomen.',
    'low blue light': 'Minder blauw licht, wat prettiger is voor je ogen bij lang werken.'
  };
  var tipN = 0;
  $$('[data-bp-label]').forEach(function (th) {
    var key = th.textContent.trim().toLowerCase(), tip = TIPS[key];
    if (!tip) { for (var k in TIPS) { if (key.indexOf(k) === 0) { tip = TIPS[k]; break; } } }
    if (!tip) return;
    var id = 'bp-tip-' + (++tipN);
    var w = document.createElement('span');
    w.className = 'bp-tipw';
    w.innerHTML = '<button type="button" class="bp-tip" aria-expanded="false" aria-controls="' + id + '" aria-label="Wat betekent ' + th.textContent.trim().replace(/"/g, '') + '?"><span>?</span></button><span class="bp-tipbox" id="' + id + '" role="note" hidden></span>';
    w.lastChild.textContent = tip;
    th.appendChild(w);
    var btn = w.firstChild, box = w.lastChild;
    var show = function (on) { box.hidden = !on; btn.setAttribute('aria-expanded', on ? 'true' : 'false'); };
    btn.addEventListener('click', function (e) { e.stopPropagation(); show(box.hidden); });
    w.addEventListener('mouseenter', function () { if (canHover.matches) show(true); });
    w.addEventListener('mouseleave', function () { if (canHover.matches) show(false); });
  });
  document.addEventListener('click', function () { $$('.bp-tipbox').forEach(function (b) { if (!b.hidden) { b.hidden = true; b.previousSibling.setAttribute('aria-expanded', 'false'); } }); });

  /* Productrijen: pijlen op desktop */
  $$('[data-bp-arrows]').forEach(function (ar) {
    var row = $('[data-bp-row]', ar.closest('.mmx-wrap'));
    if (!row) return;
    var btns = $$('button', ar);
    var upd = function () { btns[0].disabled = row.scrollLeft < 5; btns[1].disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 5; ar.hidden = row.scrollWidth <= row.clientWidth + 5; };
    btns.forEach(function (b) { b.addEventListener('click', function () { row.scrollBy({ left: +b.getAttribute('data-dir') * row.clientWidth * 0.75, behavior: 'smooth' }); }); });
    row.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    setTimeout(upd, 50);
  });

  /* Inhoudsbalk: actieve sectie, koopknop zodra de echte knop uit beeld is */
  var tocLinks = $$('.bp-toc ul a');
  if ('IntersectionObserver' in window) {
    var targets = tocLinks.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); }).filter(Boolean);
    var io = new IntersectionObserver(function () {
      var best = null;
      targets.forEach(function (t) { var r = t.getBoundingClientRect(); if (r.top < window.innerHeight * 0.4) best = t; });
      tocLinks.forEach(function (a) { a.classList.toggle('is-on', !!best && a.getAttribute('href') === '#' + best.id); });
    }, { rootMargin: '0px 0px -50% 0px', threshold: [0, 0.25, 0.5, 1] });
    targets.forEach(function (t) { io.observe(t); });
    window.addEventListener('scroll', function () { io.takeRecords(); }, { passive: true });
    var sticky = $('[data-bp-sticky]');
    if (form) new IntersectionObserver(function (en) {
      var past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      root.classList.toggle('is-past', past);
      $$('[data-bp-buy]').forEach(function (b) { b.tabIndex = past ? 0 : -1; });
      if (sticky) { sticky.classList.toggle('is-on', past); sticky.setAttribute('aria-hidden', past ? 'false' : 'true'); }
      var tb = $('.bp-toc__buy'); if (tb) tb.setAttribute('aria-hidden', past ? 'false' : 'true');
    }).observe(form);
  }

  /* Laatst bekeken (alleen in deze browser) */
  var RV = 'mm-recent-v1', rvBox = $('[data-bp-rv]'), rvList = $('[data-bp-rv-list]');
  var me = { h: root.getAttribute('data-handle'), u: root.getAttribute('data-url'), t: root.getAttribute('data-title'), p: root.getAttribute('data-price'), i: root.getAttribute('data-img') || '' };
  var list = [];
  try { list = JSON.parse(localStorage.getItem(RV) || '[]'); } catch (e) { list = []; }
  if (!Array.isArray(list)) list = [];
  var others = list.filter(function (x) { return x && x.h && x.h !== me.h; }).slice(0, 10);
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  if (rvBox && others.length) {
    rvList.innerHTML = others.map(function (x) { return '<li><a class="bp-rv__item" href="' + esc(x.u) + '"><span class="bp-rv__img">' + (x.i ? '<img src="' + esc(x.i) + '" alt="" loading="lazy">' : '') + '</span><strong>' + esc(x.t) + '</strong><span>' + esc(x.p) + '</span></a></li>'; }).join('');
    rvBox.hidden = false;
  }
  try { localStorage.setItem(RV, JSON.stringify([me].concat(others).slice(0, 12))); } catch (e) {}
  var clr = $('[data-bp-rv-clear]');
  if (clr) clr.addEventListener('click', function () { try { localStorage.setItem(RV, JSON.stringify([me])); } catch (e) {} rvBox.hidden = true; });
})();
